import React, { useEffect, useState } from "react";
import { Loader2, Sparkles, X } from "lucide-react";

export default function DegerKaybiOgrenmeModal({ open, row, onClose, onSubmit, busy }) {
    const [gercek, setGercek] = useState("");

    useEffect(() => {
        if (open && row) {
            setGercek(
                row.deger_kaybi != null && row.deger_kaybi !== ""
                    ? String(row.deger_kaybi)
                    : "",
            );
        }
    }, [open, row]);

    if (!open || !row) return null;

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <div
                role="dialog"
                aria-modal
                className="w-full max-w-md rounded-xl border border-violet-500/30 bg-[#121A2F] shadow-2xl"
            >
                <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
                    <div className="flex items-center gap-2 text-sm font-medium text-white">
                        <Sparkles className="h-4 w-4 text-violet-400" />
                        Bilirkişi / tahkim sonucu
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-1 rounded-md text-slate-400 hover:text-white hover:bg-white/10"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
                <div className="p-4 space-y-3">
                    <p className="text-xs text-slate-400 leading-relaxed">
                        <strong className="text-slate-200">{row.dosya_no}</strong> — motorun öğrenme
                        çarpanı güncellenir; mevcut dosya DK tutarı değiştirilmez.
                    </p>
                    <label className="block">
                        <span className="text-[10px] uppercase tracking-wider text-slate-500">
                            Gerçekleşen DK (₺)
                        </span>
                        <input
                            type="number"
                            min="1"
                            step="0.01"
                            value={gercek}
                            onChange={(e) => setGercek(e.target.value)}
                            className="mt-1 w-full bg-[#0B0F19] border border-white/10 rounded-md px-3 py-2 text-sm text-white focus:border-violet-400 outline-none"
                            placeholder="Örn. 125000"
                        />
                    </label>
                    {row.deger_kaybi != null && (
                        <p className="text-[11px] text-slate-500">
                            Sistem hesabı:{" "}
                            <span className="text-slate-300 font-mono">
                                {Number(row.deger_kaybi).toLocaleString("tr-TR")} ₺
                            </span>
                        </p>
                    )}
                </div>
                <div className="flex justify-end gap-2 px-4 py-3 border-t border-white/10">
                    <button
                        type="button"
                        onClick={onClose}
                        className="h-9 px-3 rounded-md border border-white/10 text-xs text-slate-400 hover:text-white"
                    >
                        İptal
                    </button>
                    <button
                        type="button"
                        disabled={busy || !gercek || Number(gercek) <= 0}
                        onClick={() => onSubmit(Number(gercek))}
                        className="h-9 px-4 rounded-md bg-violet-600/80 hover:bg-violet-600 text-xs text-white inline-flex items-center gap-2 disabled:opacity-50"
                    >
                        {busy ? (
                            <Loader2 className="h-3.5 w-3.5 animate-spin" />
                        ) : (
                            <Sparkles className="h-3.5 w-3.5" />
                        )}
                        Öğrenmeye kaydet
                    </button>
                </div>
            </div>
        </div>
    );
}
